import pageStyle from "./index.module.less";

export default {
    name: "SelectTicketStatus",
    data() {
        return {
            pageStyle
        };
    },
    model: {
        prop: "value",
        event: "change"
    },
    props: {
        value: [Number, String]
    },
    methods: {
        onChange(value) {
            this.$emit("change", value);
        }
    }
};
